import React, { useState } from "react";
import "./accordion.scss";

const Accordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleAccordion();
    }
  };

  return (
    <div className="accordion">
      <div
        className="accordion__header"
        onClick={toggleAccordion}
        role="button"
        aria-expanded={isOpen}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <span>{title}</span>
        <span>
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="12 11 8 7 4 11" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="4 5 8 9 12 5" />
            </svg>
          )}
        </span>
      </div>
      <div
        className={`accordion__wrapper ${
          isOpen ? "accordion__wrapper--open" : ""
        }`}
      >
        <div className="accordion__content">
          {React.Children.map(content.props.children, (child) =>
            React.isValidElement(child) && child.type === "a"
              ? React.cloneElement(child, { tabIndex: isOpen ? 0 : -1 })
              : child
          )}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
